<template>
    <EasyDataTable
    v-if="finalTableItems.length > 0"
    header-text-direction="center"
    table-class-name="customize-table"
    :headers="HEADERS_VIRTMACH"
    :items="finalTableItems"
    :rows-per-page="rows"
    >
        <template #header-porcCPU="header">
            <div class="header_container">
                <div>{{ header.text }}</div>
                <div>(% {{ t('labels.available') }})</div>
            </div>
        </template>
        <template #header-porcMemor="header">
            <div class="header_container">
                <div>{{ header.text }}</div>
                <div>(% {{ t('labels.available') }})</div>
            </div>
        </template>
        <template #header-porcDisco="header">
            <div class="header_container">
                <div>{{ header.text }}</div>
                <div>(% {{ t('labels.available') }})</div>
            </div>
        </template>
        <template #item-state="item">
            <v-row justify="center" class="ma-0">
                <v-icon
                v-if="item.CPUActual === 0"
                color="red"
                >
                    mdi-monitor-screenshot
                </v-icon>
                <v-icon
                v-else
                color="green"
                >
                    mdi-monitor-screenshot
                </v-icon>
                <span class="pl-2" v-if="item.CPUActual === 0"> OFF </span>
                <span class="pl-3" v-else> ON </span>
            </v-row>
        </template>       
        <template #item-porcDisco="item">
        <v-row class="ma-0">
            <v-col cols="6" class="text-end pa-0  pr-1">
                {{item.dispDisco}}% 
            </v-col>
            <v-col class="pa-0" cols="6" align-self="center">
                <v-progress-linear
                :model-value="item.porcDisco"
                height="10"
                striped
                rounded
                :color="
                item.porcDisco > 80 ? '#FF0000' : item.porcDisco <= 80 && item.porcDisco >= 50 ? '#FFEE00' :'#00FF00'"
                ></v-progress-linear>
            </v-col>
        </v-row>
        </template>   

        <template #item-porcCPU="item">
            <v-row class="ma-0">
                <v-col cols="5" class="text-end pa-0 pr-1" >
                    {{ item.dispCPU }}% 
                </v-col>
                <v-col class="pa-0" cols="7" align-self="center">
                    <v-progress-linear
                    :model-value="item.porcCPU"
                    height="10"
                    striped
                    rounded
                    :color="
                    item.porcCPU > 80 ? '#FF0000' : item.porcCPU <= 80 && item.porcCPU > 50 ? '#FFEE00' :'#00FF00'"
                    ></v-progress-linear>
                </v-col>
            </v-row>                           
        </template>   

        <template #item-porcMemor="item">
            <v-row class="ma-0">
                <v-col cols="5" class="text-end pa-0 pr-1" >
                    {{ item.dispMemor }}% 
                </v-col>
                <v-col class="pa-0" cols="7" align-self="center">
                    <v-progress-linear
                    :model-value="item.porcMemor"
                    height="10"
                    striped
                    rounded
                    :color="
                    item.porcMemor > 80 ? '#FF0000' : item.porcMemor <= 80 && item.porcMemor > 50 ? '#FFEE00' :'#00FF00'"
                    ></v-progress-linear>
                </v-col>
            </v-row>
        </template>       
    </EasyDataTable>
    <Prog_circular v-else/>

</template>

<script setup lang="ts">
import { ref, Ref, onMounted, watch, computed } from 'vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
import { FINAL_HEADERS_TABLE } from '@/constants/tableHeaders';
import { LABELS } from '@/constants/labels';

/********************************
 ********** COMPONENTS **********
 *******************************/
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { getVirMacServerByIP } from '@/services/Smartlink/Server';
import { VIRMAC } from '@/interfaces/SmartLink/Server';
import { HEADER } from '@/interfaces/SmartLink/Tables';

const props = defineProps({
    ip          : { required:true, type:Array<string> },
    rows        : { required:true, type:Number },
    recharge    : { required:true, type:Boolean },
    emited      : { required:true, type:Boolean },
})


/**
 * Del Dashboard cuando recargas los datos cada 15 minutos o dandole
 * al botón de recarga
 */
const isRecharge                = computed(() => props.recharge);

/**
 * Si la consulta a la API, tiene valores
 */
const isDataLength              = ref(true);

/**
 * Array de IPs que vienen del padre, mayormente del Dashboard
 */
const computeipsArray           = computed(() => props.ip)

/**
 * Copia de computeipsArray, con el propósito de que se modifique
 */
const ipsArray                  = ref(computeipsArray.value)

const finalTableItems:Ref<VIRMAC[]>     = ref([]);

/**
 * Captura los valores de la API: "getVirMacServer"
 * mandando como parámetro la IP del servidor 
 */
const getMVSDialog = async () => {
    
    // Se coloca el valor true para que cuando no hayan valores
    // pase a false y ejecute el watch 
    isDataLength.value      = true;

    // Cuando hace todo el recorrido y no encuentra valores, oculta la vista
    if(ipsArray.value.length === 0){
        store.commit('setVirtualMachine', false);
    }

    // Cuando el array tiene al menos un valor 
    else{
        let ip = ipsArray.value[0];
        finalTableItems.value = [];

        const allData = await getVirMacServerByIP({ip: ip})
    
        isDataLength.value = allData.showGraphs
        if( allData.status === 400 ){
            store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
        }
        if( allData.status === 200 ){
            finalTableItems.value = allData.data
        }
    }
}

/**
 * Cuando ha sido recargada el Dashboard, carga todo el componente de nuevo
 */
watch(isRecharge,(rech) => {
    if(rech){
        ipsArray.value = computeipsArray.value;
        getMVSDialog();
    }
})

/**
 * Cuando "isDataLength" tiene valor: "FALSE",
 * borra el valor utilizado y realiza de nuevo la
 * petición a la API
 */
watch(isDataLength,async (dataLength) => {
    if(!dataLength){
        await ipsArray.value.shift();
        await getMVSDialog();
    }
})


const header = FINAL_HEADERS_TABLE.virmac
const HEADERS_VIRTMACH:Ref<HEADER[]>   = ref(header);

onMounted(() => {
    getMVSDialog();
})

</script>

<style>

.VM_title{
    color: rgb(var(--v-theme-colorText)); 
    font-weight: bold;
    font-size: 12px;
    transition: .3s;
}

.VM_title:hover{ 
    cursor: pointer;
    transition: .3s;
    font-size: 14px;
}

</style>